module.exports = __webpack_public_path__ + "img/novak.10b53f03.jpg";